module.exports = __webpack_public_path__ + "img/dum.7f8ea213.png";